import React from "react";
import Events from "../components/Events/Events";
import { createRoot } from 'reactdom';

const EventsIndex = () => {
	const isEventsIndex = document.body.classList.contains('page-template-events');

	if (isEventsIndex) {
		const eventsContainer = document.getElementById('events-index');
		let props = {
			...(eventsContainer && eventsContainer.dataset),
		};
		const root = createRoot(eventsContainer);
		root.render(<Events {...props}/>);
	}
}

export default EventsIndex;